import { createRouter, createWebHistory } from 'vue-router'
import { authGuard } from './authGuard'

const hostname = window.location.hostname;
const subdomain = hostname.split('.')[0];

const shorthandRoutes = [
	{
		path: '/',
		name: "home",
		component: () =>
			import("@/views/Home.vue"),
		meta: {
			authRequired: false,
			layout: "AppLayoutApp",
			title: "Home",
		},
		strict: true,
	},
	{
		path: '/privacy',
		name: "privacy",
		component: () =>
			import("@/views/PrivacyPolicy.vue"),
		meta: {
			authRequired: false,
			layout: "AppLayoutApp",
			title: "Privacy Policy",
		},
		strict: true,
	},
	{
		path: '/terms',
		name: "terms",
		component: () =>
			import("@/views/TermsOfService.vue"),
		meta: {
			authRequired: false,
			layout: "AppLayoutApp",
			title: "Terms of Service",
		},
		strict: true,
	},
	{
		path: '/logout',
		name: "logout",
		component: () =>
			import("@/views/LogOut.vue"),
		meta: {
			authRequired: false,
			layout: "AppLayoutApp",
			title: "Logout",
		},
		strict: true,
	}
]


const underscoreRoutes = [
	{
		path: '/',
		name: "home",
		component: () =>
			import("@/views/Underscore.vue"),
		meta: {
			authRequired: false,
			layout: "AppLayoutApp",
			title: "Home",
		},
		strict: true,
	},
	{
		path: '/bio-tracker',
		name: "Bio Tracker",
		component: () =>
			import("@/views/BioTracker.vue"),
		meta: {
			authRequired: false,
			layout: "AppLayoutApp",
			title: "Bio Tracker",
		},
		strict: true,
	},
	{
		path: '/cashanova-logs',
		name: "Cashanova Logs",
		component: () =>
			import("@/views/CashanovaLogs.vue"),
		meta: {
			authRequired: false,
			layout: "AppLayoutApp",
			title: "Cashanova Logs",
		},
		strict: true,
	},
	{
		path: '/talent-hub-assistant',
		name: "Talent Hub Assistant",
		component: () =>
			import("@/views/TalentHubAssistant.vue"),
		meta: {
			authRequired: true,
			layout: "AppLayoutApp",
			title: "Talent Hub Assistant",
		},
		strict: true,
	},
	{
		path: '/rfp',
		name: "RFP Dashboard",
		component: () =>
			import("@/views/RFP.vue"),
		meta: {
			authRequired: false,
			layout: "AppLayoutApp",
			title: "RFP Dashboard",
		},
		strict: true,
	},
	{
		path: '/logout',
		name: "logout",
		component: () =>
			import("@/views/LogOut.vue"),
		meta: {
			authRequired: false,
			layout: "AppLayoutApp",
			title: "Logout",
		},
		strict: true,
	}
]

const router = createRouter({
	history: createWebHistory(),
	routes: subdomain === 'underscore-talent' ? underscoreRoutes : shorthandRoutes,
})

router.beforeEach(authGuard);

router.onError((err) => {
	console.log("err", err)
	router.push("/404")
})

export default router
